{
  "markread": "Marquer comme lu",
  "filter": "Filtrer",
  "newest": "Le plus récent",
  "unread": "Non lu",
  "starred": "Favoris",
  "online_count": "Sur le serveur",
  "offline_count": "En local",
  "tags": "Étiquettes",
  "alltags": "Toutes les étiquettes",
  "timestamp": "{0,date} {0,time}",
  "hours": "il y a {0,plural,one {1 heure},other {# heures}}",
  "minutes": "il y a {0,plural,one {1 minute},other {# minutes}}",
  "seconds": "il y a {0,plural,one {1 seconde},other {# secondes}}",
  "days": "{0,plural,zero {aujourd’hui},one {hier},other {il y a # jours}}",
  "star": "Ajouter aux favoris",
  "unstar": "Supprimer des favoris",
  "mark": "Marquer comme lu",
  "unmark": "Marquer comme non lu",
  "load_img": "Afficher les images",
  "open_window": "Ouvrir",
  "next": "Suivant",
  "searchbutton": "Rechercher",
  "searchremove": "Masquer le champ de recherche",
  "refreshbutton": "Actualiser les sources",
  "settingsbutton": "Paramètres",
  "logoutbutton": "Se déconnecter",
  "loginbutton": "Se connecter",
  "sources": "Sources",
  "source_add": "Ajouter une source",
  "source_opml": "ou importer un fichier OPML ou Google Reader",
  "source_export": "Exporter les sources",
  "source_edit": "Modifier",
  "source_filter": "Filtre",
  "source_delete": "Supprimer",
  "source_warn": "Voulez-vous vraiment supprimer cette source ?",
  "source_new": "Nouvelle source non sauvegardée",
  "source_title": "Titre",
  "source_autotitle_hint": "Laisser vide pour récupérer le titre",
  "source_tags": "Étiquettes",
  "source_pwd_placeholder": "Mot de passe inchangé",
  "source_comma": "Séparés par une virgule",
  "source_select": "Veuillez sélectionner une source",
  "source_type": "Type",
  "source_save": "Enregistrer",
  "source_cancel": "Annuler",
  "source_saved": "Enregistré",
  "source_last_post": "Dernier élément vu",
  "source_refresh": "Rafraîchir cette source",
  "no_entries": "Aucun article à consulter",
  "more": "Plus",
  "login": "Connexion",
  "login_username": "Identifiant",
  "login_password": "Mot de passe",
  "login_invalid_credentials": "Nom d’utilisateur/Mot de passe incorrect",
  "login_offline": "Stockage hors-ligne",
  "no_title": "Sans titre",
  "error": "Une erreur est survenue",
  "streamerror": "Une erreur s’est produite lors du chargement de la liste, essayer à nouveau ?",
  "reload_list": "Recharger la liste",
  "sources_refreshed": "Sources actualisées",
  "app_update": "selfoss a été mis à jour, merci de recharger",
  "app_reload": "Recharger",
  "error_session_expired": "Session expirée",
  "error_add_source": "Impossible d'ajouter la source :",
  "error_delete_source": "Impossible de supprimer la source :",
  "error_load_tags": "Impossible de charger les étiquettes :",
  "error_unknown_tag": "Tag inconnu :",
  "error_unknown_source": "Identifiant de source inconnu :",
  "error_mark_items": "Impossible de marquer tous les éléments visibles :",
  "error_mark_item": "Erreur lors du marquage lu/non lu :",
  "error_star_item": "Erreur lors de l’ajouter/suppression du favori :",
  "error_logout": "Impossible de se déconnecter :",
  "error_loading": "Erreur de chargement :",
  "error_loading_stats": "Impossible de charger les statistiques de navigation :",
  "error_saving_color": "Impossible de sauvegarder une nouvelle couleur :",
  "error_refreshing_source": "Impossible de rafraîchir les sources :",
  "error_sync": "Impossible de synchroniser les dernières modifications du serveur :",
  "error_offline_storage": "Erreur stockage hors-ligne : {0}. Recharger la page pourrait aider. Le mode hors-ligne est désactivé pour le moment.",
  "error_invalid_subsection": "Sous-section erronée :",
  "search_label": "Terme de recherche",
  "article_actions": "Actions",
  "error_configuration": "Impossible de charger la configuration.",
  "info_url_copied": "URL copiée dans le presse-papiers.",
  "share_native_label": "Partager",
  "share_diaspora_label": "Partager sur Diaspora",
  "share_twitter_label": "Partager sur Twitter",
  "share_facebook_label": "Partager sur Facebook",
  "share_pocket_label": "Enregistrer dans Pocket",
  "share_wallabag_label": "Enregistrer dans Wallabag",
  "share_wordpress_label": "Partager sur WordPress",
  "share_mail_label": "Partager par courriel",
  "share_copy_label": "Copier le lien dans le presse-papiers",
  "error_share_native_abort": "Impossible de partager l'élément, soit il n'y a pas de cible, soit vous avez annulé le partage.",
  "error_share_native": "Impossible de partager l'élément.",
  "close_entry": "Fermer",
  "error_unwritable_logs": "Impossible d'écrire les fichiers de journalisation.",
  "error_check_system_logs": "Une erreur est survenue. Veuillez consulter votre journalisation système.",
  "error_check_log_file": "Une erreur est survenue. Veuillez consulter le fichier « {0} ».",
  "offline_navigation_unavailable": "Modifier les étiquettes et les sources n'est pas possible hors ligne pour le moment.",
  "error_offline_storage_not_available": "Le stockage hors ligne n’est pas disponible. Assurez-vous que votre navigateur Web {0}prend en charge l’API IndexedDB{1} et, si vous utilisez un navigateur basé sur Google Chrome, que vous n’exécutez pas selfoss en mode de navigation privée.",
  "error_edit_source": "Impossible d'enregistrer les modifications de la source :",
  "source_browse": "Naviguer",
  "no_sources": "Aucune source configurées.",
  "source_warn_cancel_dirty": "Annuler les changements non sauvegardés ?",
  "source_deleting": "Suppression de la source…",
  "source_saving": "Sauvegarde des changements de la source…",
  "entries_loading": "Chargement des entrées…",
  "source_menu": "Plus d'actions",
  "tag_change_color_button_title": "Changer la couleur",
  "sources_loading": "Chargement des sources…",
  "source_go_to_settings": "Ouvrir dans les paramètres",
  "sources_leaving_unsaved_prompt": "Quitter les paramètres avec des changements sur la source non sauvegardés ?",
  "source_params_loading": "Chargement des paramètres…",
  "experimental": "Expérimentale",
  "article_reading_time": "{0} min de lecture",
  "login_in_progress": "Tentative de connexion…",
  "login_error_generic": "Connexion impossible : {errorMessage}",
  "error_unauthorized": "S'il vous plaît {link_begin}connectez-vous{link_end} pour continuer."
}
